import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {IResultAccounts} from 'src/app/models/accounts/accountsetting.model';


@Injectable({
  providedIn: 'root'
})
export class AccountsHttpService {
  constructor(private http: HttpClient) {
  }


  filter(
    wheres: { [key: string]: string }, search: string,
    limit: number = 100,
    offset: number = 0,
    sortField: string = '',
    sortOrder: 'asc' | 'desc' = 'asc', enableordisable: any,
    accountid: any,
  ): Observable<IResultAccounts> {
    let params = new HttpParams().set('expand', 'practice,role,user')
      .set('fields', 'is_verified,practice.name,role.name,id,full_name,user.last_login')
    // .set('search', search);

    // Object.keys(wheres).forEach((key) => {
    //   params = params.append(key, wheres[key]);
    // });


    params = params.append('offset', offset.toString());
    params = params.append('limit', limit.toString());


    if (sortField) {
      params = params.append('ordering', `${sortOrder === 'desc' ? '-' : ''}${sortField}`);
    }
    const practice_id = wheres['practice_id'];
    let url = `${environment.apiUrl}/accounts/account_list/?practice_id=${practice_id}&search=${search}`;

    if (enableordisable != '' && accountid != '') {

      let urlupdatestatus = `${environment.apiUrl}/accounts/account_list/${accountid}/${enableordisable}/?practice_id=${practice_id}`;
      this.http.get<IResultAccounts>(urlupdatestatus, {params});
    }

    if (sortField) {
      params = params.append('ordering', `${sortOrder === 'desc' ? '-' : ''}${sortField}`);
    }


    return this.http.get<IResultAccounts>(url, {params});


  }

  updateStatus(accountid: any, enableordisable: any, practice_id: string): Observable<any> {
    let url = `${environment.apiUrl}/accounts/account_list/${accountid}/${enableordisable}/?practice_id=${practice_id}`;
    return this.http.post<any>(url, {});
  }

}
